module.exports = __webpack_public_path__ + "img/RCloudUser.96619896.png";